import React from 'react'
import { View, TouchableOpacity, Image, Text } from 'react-native'
import styles from '../../styles'
import { BodyNormalDark, CaptionBoldDark, ProfileAvatar, CircleButton } from '../../components'
import { getRolename } from '../../functions'
import arrow_right from '../../assets/icon/right_filled.png'
import { global, colors } from '../../const'
import family_ic from '../../assets/icon/family_ic.png'
import villageIcon from '../../assets/icon/villageTeam.png'
import localize from '../../localize'
import { PrimaryTitle } from '../labels'

function ProfileList ({ data, type, props }) {
  const kind = data.kind === 1 ? localize.Family : localize.Team

  const _navigate = (pathname, state, search) => {
    if (!global.isNative) {
      return props.history.push({
        pathname: '/' + pathname,
        state,
        search
      })
    } else {
      return props.navigation.push(pathname, state)
    }
  }

  if (type === 'team') {
    return (
      <TouchableOpacity
        onPress={() => _navigate(data.kind === 1 ? !global.isNative ? 'profile/family-profile' : 'family_team' : !global.isNative ? 'profile/team-profile' : 'team', data, `id=${data.id}&name=${data.name}`)}
        activeOpacity={0.8}
      >
        <View style={styles.chatRow}>
          <View style={{ flexDirection: 'row', marginLeft: 18, flex: 1 }}>

            <View>
              <View style={{ height: 50, width: 50 }}>
                <ProfileAvatar
                  src={data.kind === 1 ? family_ic : villageIcon}
                  size='75%'
                />
              </View>

              {
                data.event !== 0
                  ? <View style={{
                    height: 20,
                    width: 20,
                    borderRadius: 10,
                    backgroundColor: colors.alert,
                    position: 'absolute',
                    alignSelf: 'flex-end',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginLeft: 4,
                    marginTop: -4
                  }}
                  >
                    <Text style={{
                      color: colors.white,
                      fontFamily: global.FONT_REGULAR,
                      fontSize: 12,
                      alignSelf: 'center'
                    }}
                    >{data.event}
                    </Text>
                  </View>
                  : null
              }

            </View>

            <View style={{ paddingLeft: 10, flex: 1 }}>
              <CaptionBoldDark title={kind} />
              <BodyNormalDark title={data.name} />
              <PrimaryTitle size={12} customStyle={{ flex: 1 }}>Click here to see the Life-skills Learning Portfolio for your Children</PrimaryTitle>
            </View>

          </View>
          <View style={{ justifyContent: 'center' }}>
            <CircleButton
              component={
                <Image
                  source={arrow_right}
                  style={{ height: 16, width: 16 }}
                  resizeMode='contain'
                />
              }
              onPress={() => _navigate(data.kind === 1 ? !global.isNative ? 'profile/family-profile' : 'family_team' : !global.isNative ? 'profile/team-profile' : 'team', data, `id=${data.id}&name=${data.name}`)}
            />
          </View>
        </View>
        <View style={{
          height: 1,
          backgroundColor: colors.lightGray,
          width: '100%'
        }}
        />
      </TouchableOpacity>
    )
  }

  const userRole = getRolename(data.role_type)
  return (

    <TouchableOpacity
      onPress={() => _navigate(global.isNative ? 'member_profile' : 'profile/member-profile', data, `id=${data.id}&nickname=${data.nickname}&thumb=${data.avatar}&role=${data.role_type}`)}
      activeOpacity={0.8}
    >
      <View style={styles.chatRow}>
        <View style={{ flexDirection: 'row', marginLeft: 18, alignItems: 'center' }}>
          <View style={{ height: 50, width: 50 }}>
            <ProfileAvatar src={{ uri: global.MAKEURL(data.avatar) }} />
          </View>
          <View style={{ paddingLeft: 10 }}>
            <CaptionBoldDark title={userRole} />
            <BodyNormalDark title={data.nickname} />
          </View>
        </View>
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <PrimaryTitle size={12} customStyle={{ width: 100 }}>Click here to see their Progress</PrimaryTitle>
          <CircleButton
            component={(<Image source={arrow_right} style={{ height: 16, width: 16 }} resizeMode='contain' />)}
            onPress={() => null}
          />
        </View>
      </View>
      <View style={[{ height: 1, width: '100%' }, styles.bglightGray]} />
    </TouchableOpacity>
  )
}

export default ProfileList
